import { defaultInitialState, defaultApiState, loadingState, updatedState, getErrorState } from '../utils';
import { GET_D2D_PILLS, GET_D2D_PILLS_DONE, GET_D2D_PILLS_ERR, RESET_PILLS, SOFT_RESET_PILLS } from './actionTypes';
import { ADD_D2D_PILL, ADD_D2D_PILL_DONE, ADD_D2D_PILL_ERR, EDIT_D2D_PILL, EDIT_D2D_PILL_DONE, EDIT_D2D_PILL_ERR, EDIT_D2D_PILL_SCHEDULE, REMOVE_D2D_PILL, REMOVE_D2D_PILL_DONE, REMOVE_D2D_PILL_ERR } from '../pill/actionTypes';
import { SET_PASSCODE_DONE, REMOVE_PASSCODE_DONE } from '../accountPasscode/actionTypes';
import applyEditPill from './applyEditPill';
const initialState = Object.assign(Object.assign({}, defaultInitialState), { data: {
        config: {
            parental_lock: null,
            pills: [],
            timezone_offset: null,
            travel_mode: false,
            update_error: null,
            update_error_msg: null
        },
        pending_changes: false
    } });
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_D2D_PILLS:
        case ADD_D2D_PILL:
        case EDIT_D2D_PILL:
        case REMOVE_D2D_PILL:
            return Object.assign(Object.assign({}, state), loadingState);
        case GET_D2D_PILLS_ERR:
        case ADD_D2D_PILL_ERR:
        case EDIT_D2D_PILL_ERR:
        case REMOVE_D2D_PILL_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.errorMessage));
        case GET_D2D_PILLS_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), defaultApiState), { data: action.data });
        case ADD_D2D_PILL_DONE:
            return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { config: Object.assign(Object.assign({}, state.data.config), { pills: [...state.data.config.pills, action.data] }) }) }), updatedState), { isAutoApplied: action.data.isAutoApplied });
        case EDIT_D2D_PILL_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), updatedState), { isAutoApplied: action.data.isAutoApplied });
        case EDIT_D2D_PILL_SCHEDULE:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { config: Object.assign(Object.assign({}, state.data.config), { pills: applyEditPill(state.data.config.pills, action.data) }) }) });
        case REMOVE_D2D_PILL_DONE:
            return Object.assign(Object.assign(Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { config: Object.assign(Object.assign({}, state.data.config), { pills: state.data.config.pills.filter((pill) => pill.slot !== action.data.slot) }) }) }), updatedState), { isAutoApplied: action.data.isAutoApplied });
        case SET_PASSCODE_DONE:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { config: Object.assign(Object.assign({}, state.data.config), { parental_lock: action.data.pin }) }) });
        case REMOVE_PASSCODE_DONE:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { config: Object.assign(Object.assign({}, state.data.config), { parental_lock: null }) }) });
        case SOFT_RESET_PILLS:
            return Object.assign(Object.assign(Object.assign({}, state), defaultApiState), { isAutoApplied: undefined });
        case RESET_PILLS:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map